// FilterTags.tsx
import React from 'react';
import { FilterState } from './types'; // You'll need to move the FilterState interface to a separate types file

interface CountryData {
  code: string;
  emoji: string;
}

interface FilterTagProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

const FilterTag: React.FC<FilterTagProps> = ({ label, active, onClick }) => (
  <button
    onClick={onClick}
    className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
      active 
        ? 'bg-primary text-white' 
        : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
    }`}
  >
    {label}
  </button>
);

const COMMON_COUNTRIES: CountryData[] = [
  { code: 'CL', emoji: '🇨🇱' },
  { code: 'SE', emoji: '🇸🇪' },
  { code: 'US', emoji: '🇺🇸' },
  { code: 'CO', emoji: '🇨🇴' },
  { code: 'IT', emoji: '🇮🇹' },
  { code: 'VE', emoji: '🇻🇪' },
  { code: 'AR', emoji: '🇦🇷' },
  { code: 'ES', emoji: '🇪🇸' },
  { code: 'VN', emoji: '🇻🇳' },
  { code: 'PE', emoji: '🇵🇪' },
  { code: 'SV', emoji: '🇸🇻' },
  { code: 'IN', emoji: '🇮🇳' }
];

const USER_TYPES = [
  { label: '💰 Paid', value: 'true' },
  { label: '🆓 Free', value: 'false' }
];

const PLATFORMS = [
  { label: '📱 Android', value: 'Android' },
  { label: '🍎 iOS', value: 'iOS' },
  { label: '🖥️ macOS', value: 'macOS' }
];

const MODES = [
  { label: '💬 Chat', value: 'chat' },
  { label: '📝 Feedback', value: 'feedback' },
  { label: '📋 Summary', value: 'summary' }
];

interface FilterTagsProps {
  filterInputs: FilterState;
  onFilterChange: (type: 'country' | 'paidUser' | 'platform' | 'mode', value: string) => void;
}

const FilterTags: React.FC<FilterTagsProps> = ({ filterInputs, onFilterChange }) => {
  return (
    <div className="lg:col-span-4 space-y-4 pb-6">
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-300">Quick Filters - Countries</label>
        <div className="flex flex-wrap gap-2">
          {COMMON_COUNTRIES.map(country => (
            <FilterTag
              key={country.code}
              label={`${country.emoji} ${country.code}`}
              active={filterInputs.country === country.code}
              onClick={() => onFilterChange('country', country.code)}
            />
          ))}
        </div>
      </div>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-300">User Type</label>
        <div className="flex flex-wrap gap-2">
          {USER_TYPES.map(type => (
            <FilterTag
              key={type.value}
              label={type.label}
              active={filterInputs.paidUser === type.value}
              onClick={() => onFilterChange('paidUser', type.value)}
            />
          ))}
        </div>
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-300">Platform</label>
        <div className="flex flex-wrap gap-2">
          {PLATFORMS.map(platform => (
            <FilterTag
              key={platform.value}
              label={platform.label}
              active={filterInputs.platform === platform.value}
              onClick={() => onFilterChange('platform', platform.value)}
            />
          ))}
        </div>
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-300">Mode</label>
        <div className="flex flex-wrap gap-2">
          {MODES.map(mode => (
            <FilterTag
              key={mode.value}
              label={mode.label}
              active={filterInputs.mode === mode.value}
              onClick={() => onFilterChange('mode', mode.value)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterTags;